/* =============================================================

  定数
  
============================================================= */
const paramNmStaticSearch = {
  sortBy: "sort_by",
  gridList: "grid_list",
};

/* =============================================================

  初期処理
  
============================================================= */
window.addEventListener("DOMContentLoaded", function () {
  // GETパラメータ
  var urlParams = new URLSearchParams(window.location.search);
  var valueSortBy = urlParams.get(paramNmStaticSearch.sortBy);
  var valueGridList = urlParams.get(paramNmStaticSearch.gridList);

  // GETパラメータから「並び替え」の値を変更
  var selectBox = document.getElementById("product_grid_sort_pc");
  var options = selectBox.options;
  if (valueSortBy) {
    for (var i = 0; i < options.length; i++) {
      if (options[i].value === valueSortBy) {
        options[i].setAttribute("selected", "selected");
        selectBox.selectedIndex = i;
        break;
      }
    }
  }

  // 「並び替える」専用モーダルをレンダリング
  if (valueSortBy == null) {
    valueSortBy = "relevance";
  }
  renderSortByModalStaticSearch(valueSortBy);

  // GETパラメータから「表示を変える」の現在選択を変更
  if (valueGridList == null) {
    valueGridList = "grid-view";
  }
  document
    .querySelectorAll(
      `.utils-viewtoggle-button[data-collection-view=${valueGridList}]`
    )
    .forEach((elem) => {
      elem.classList.add("active");
    });

  // GETパラメータから一覧の表示形式を切り替え（4カラム or 1カラム）
  const elemProductItems = document.querySelector(".productgrid--items");
  if (elemProductItems) {
    switch (valueGridList) {
      case "grid-view":
        // 4カラム： 処理不要
        break;
      case "list-view":
        // 1カラム： 独自クラスで強制的に上書き
        elemProductItems.classList.add("override-products-per-row-1");
        break;
    }
  }
});

/* =============================================================

  「並び替え」
  
============================================================= */
/**
  「並び替え」変更イベント（PC向け）
*/
document
  .getElementById("product_grid_sort_pc")
  .addEventListener("change", function () {
    const param = {
      key: paramNmStaticSearch.sortBy,
      value: this.value,
    };
    reloadStaticSearch(param);
  });

/**
  「並び替え」クリックイベント（SP向け）
*/
document.querySelectorAll(".utils-sortby-button").forEach((button) => {
  button.addEventListener("click", () => {
    openModalSortBy();
  });
});

/**
  並び替えモーダルをレンダリング（SP向け）
*/
function renderSortByModalStaticSearch(valueSortBy) {
  // コンポーネント
  const modalContent = document.createElement("div");
  modalContent.classList.add("modal");
  modalContent.classList.add("modal--productgrid-sort");
  modalContent.classList.add("allow-scroll-while-locked");
  modalContent.setAttribute("id", "modal-sortby-static-search");
  modalContent.setAttribute("data-modal-container", "");
  modalContent.setAttribute("aria-label", "modal window");
  modalContent.setAttribute("data-trap-focus", "");
  modalContent.setAttribute("tabindex", "-1");
  modalContent.innerHTML = `
      <div class="modal-inner modal-inner-sort" data-modal-inner="">
        <button class="modal-close" type="button" aria-label="閉じる" data-modal-close="">
          <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
            <path fill="currentColor" fill-rule="evenodd" d="M5.306 6.5L0 1.194 1.194 0 6.5 5.306 11.806 0 13 1.194 7.694 6.5 13 11.806 11.806 13 6.5 7.694 1.194 13 0 11.806 5.306 6.5z"></path>
          </svg>
        </button>
        <div class="modal-content" data-modal-content="">
          <span class="utils-sortby--modal-title">並び替え</span>
          <ul class="utils-sortby--modal-list">
            <li class="utils-sortby--modal-item"><button class="utils-sortby--modal-button ${
              valueSortBy == "relevance"
                ? "utils-sortby--modal-button--active"
                : ""
            }" value="relevance" data-productgrid-trigger-sort-button="">オススメ</button></li>
            <li class="utils-sortby--modal-item"><button class="utils-sortby--modal-button ${
              valueSortBy == "price-ascending"
                ? "utils-sortby--modal-button--active"
                : ""
            }" value="price-ascending" data-productgrid-trigger-sort-button="">価格の安い順</button></li>
            <li class="utils-sortby--modal-item"><button class="utils-sortby--modal-button ${
              valueSortBy == "price-descending"
                ? "utils-sortby--modal-button--active"
                : ""
            }" value="price-descending" data-productgrid-trigger-sort-button="">価格の高い順</button></li>
          </ul>
        </div>
      </div>`;
  modalContent.style.visibility = "hidden";
  document.body.appendChild(modalContent);

  // 選択肢クリックイベント
  const activeClassNm = "utils-sortby--modal-button--active";
  document.querySelectorAll(".utils-sortby--modal-button").forEach((button) => {
    if (!button.classList.contains(activeClassNm)) {
      button.addEventListener("click", () => {
        // activeクラス付け替え
        document
          .querySelector("." + activeClassNm)
          .classList.remove(activeClassNm);
        button.classList.add(activeClassNm);

        // リロード
        const param = {
          key: paramNmStaticSearch.sortBy,
          value: button.value,
        };
        reloadStaticSearch(param);
      });
    }
  });

  // クローズクリックイベント
  document
    .querySelector("#modal-sortby-static-search .modal-close")
    .addEventListener("click", function (event) {
      closeModalSortBy();
    });
}

/**
  モーダルオープン
*/
function openModalSortBy() {
  // bodyにモーダル表示用クラスを付与
  document.body.classList.add("modal-loaded", "modal-visible");

  // スクロール無効化
  document.body.style.overflow = "hidden";

  // デフォルトモーダルを非表示
  document.querySelector(".modal-inner").style.display = "none";

  // 独自モーダルを表示
  document.querySelector("#modal-sortby-static-search").style.visibility =
    "visible";

  // 独自モーダルに位置調整
  setTimeout(function () {
    document
      .querySelector("#modal-sortby-static-search .modal-inner")
      .classList.add("modal-inner-sort-down");
  }, 100);
}

/**
  モーダルクローズ
*/
function closeModalSortBy() {
  // bodyからモーダル表示用クラスを削除
  document.body.classList.remove("modal-loaded", "modal-visible");

  // スクロール有効化
  document.body.style.overflow = "auto";

  // デフォルトモーダルを表示
  document.querySelector(".modal-inner").style.display = "block";

  // 独自モーダルを非表示
  document.querySelector("#modal-sortby-static-search").style.visibility =
    "hidden";

  // 独自モーダルに位置調整
  document
    .querySelector("#modal-sortby-static-search .modal-inner")
    .classList.remove("modal-inner-sort-down");
}

/* =============================================================

  「表示を変える」
  
============================================================= */
/**
  「表示を変える」クリックイベント
*/
document.querySelectorAll(".utils-viewtoggle-button").forEach((button) => {
  button.addEventListener("click", () => {
    const param = {
      key: paramNmStaticSearch.gridList,
      value: button.dataset.collectionView,
    };
    reloadStaticSearch(param);
  });
});

/* =============================================================

  ユーティリティ
  
============================================================= */
/**
  パラメータを追加して検索画面をリロード
*/
function reloadStaticSearch(param) {
  const url = new URL(window.location.href);
  url.searchParams.set(param.key, param.value);
  window.location.href = url.toString();
}
